import React, { useState, useEffect, Fragment } from "react";
import ReactSelect from "react-select";
import { OfferTypes } from "../constants/selections";

const OfferType = ({ onChangeType, isVisible, type }) => {
  const [offerType, setOfferType] = useState(type ? type : "perk");
  useEffect(() => {
    onChangeType(offerType);
  }, [offerType]);

  const handleSelectType = (value) => {
    const type = value.value;
    setOfferType(type);
  };
  return (
    <div
      className={`${!isVisible ? "d-none" : ""} mt-3`}
      style={{ textAlign: "left", width: "100%" }}
    >
      <div className="form-group row">
        <div className="col-12">
          <ReactSelect
            value={
              offerType
                ? OfferTypes.find((item) => item.value === offerType)
                : null
            }
            onChange={handleSelectType}
            options={OfferTypes}
            placeholder="Select an offer type you'd like to broadcast to feeds"
            isSearchable={false}
          ></ReactSelect>
        </div>
      </div>
    </div>
  );
};
export default OfferType;



// WEBPACK FOOTER //
// ./src/screens/Perks/components/OfferType.js